export default "__VITE_ASSET__DBv$ji26__"